(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-quantity-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quick-quantity-selector')) {
    class QuickQuantitySelector extends HTMLButtonElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.quantity = parseInt(this.getAttribute('data-quantity') || '1', 10);
        this.discountPercentage = parseInt(this.getAttribute('data-discount-percentage') || '0', 10);

        this.selectedVariantPrice = parseInt(this.getAttribute('data-selected-variant-price') || '0', 10);
        this.selectedVariantCompareAtPrice = parseInt(this.getAttribute('data-selected-variant-compare-at-price') || '0', 10);
        this.selectedVariantUnitPrice = parseInt(this.getAttribute('data-selected-variant-unit-price') || '0', 10);

        this.addEventListener('click', this.handleClick.bind(this));

        this.connectedQuantityInputElement.addEventListener('change', this.handleQuantityInputChange.bind(this));

        globalThis.addEventListener('variant:change', this.handleVariantChange.bind(this));
      }

      handleClick() {
        // Update the quantity input element with the value of this button.
        if (this.connectedQuantityInputElement) {
          this.connectedQuantityInputElement.quantity = this.quantity;
        }

        this.updatePrices();
        this.updateOptionLabel();
      }

      handleQuantityInputChange(event) {
        const selectedQuantity = parseInt(event.target.value, 10);
        const allQuantityPresetsReversed = [...this.parentNode.children]
          .map((child) => parseInt(child.getAttribute('data-quantity'), 10))
          .reverse();

        if (allQuantityPresetsReversed.find((quantity) => selectedQuantity >= quantity) === this.quantity) {
          this.check();
        } else {
          this.uncheck();
        }

        if (selectedQuantity >= this.quantity) {
          this.updatePrices();
          this.updateOptionLabel();
        }
      }

      handleVariantChange(event) {
        const { variant } = event.detail;

        this.selectedVariantPrice = variant.price;
        this.selectedVariantCompareAtPrice = variant.compare_at_price || 0;
        this.selectedVariantUnitPrice = variant.unit_price || 0;

        this.updateDiscountTag();

        if (this.isChecked()) {
          this.updatePrices();
        }
      }

      isChecked() {
        return this.classList.contains('checked');
      }

      updateDiscountTag() {
        this.discountTagElement.textContent = this.discountTagElement.textContent.split(": ")[0] + ": " + this.formatPrice(
          this.selectedVariantPrice * (1 - this.discountPercentage / 100)
        );
      }

      updatePrices() {
        if (this.connectedSalePriceElement) {
          const adjustedPriceCents = this.selectedVariantPrice * (1 - this.discountPercentage / 100);

          this.connectedSalePriceElement.textContent = this.formatPrice(adjustedPriceCents);
        }

        if (this.connectedUnitPriceElement) {
          const adjustedPriceCents = this.selectedVariantUnitPrice * (1 - this.discountPercentage / 100);

          // The textContent is in this format: (54€/m2)
          this.connectedUnitPriceElement.textContent = `(${this.formatPrice(adjustedPriceCents)}/m2)`;
        }

        if (this.connectedOnSaleBadgeElement) {
          const adjustedPriceCents = this.selectedVariantPrice * (1 - this.discountPercentage / 100);
          this.connectedOnSaleBadgeElement.textContent = `Spare ${this.formatPrice(this.selectedVariantCompareAtPrice - adjustedPriceCents)}`;
        }

        if (this.connectedOnSaleBadgeExperimentElement) {
          if (this.discountPercentage > 0) {
            const adjustedPriceCents = this.selectedVariantPrice * (1 - this.discountPercentage / 100);

            this.connectedCompareAtPriceExperimentElement.textContent = this.formatPrice(this.selectedVariantPrice);
            this.connectedCompareAtPriceExperimentElement.removeAttribute('hidden');

            this.connectedOnSaleBadgeExperimentElement.textContent = `Spare ${this.formatPrice(this.selectedVariantPrice - adjustedPriceCents)}`;
            this.connectedOnSaleBadgeExperimentElement.removeAttribute('hidden');
          } else {
            this.connectedCompareAtPriceExperimentElement.setAttribute('hidden', '');
            this.connectedOnSaleBadgeExperimentElement.setAttribute('hidden', '');
          }
        }
      }

      updateOptionLabel() {
        if (this.connectedOptionLabelElement) {
          this.connectedOptionLabelElement.textContent = this.labelElement.textContent;
        }
      }

      formatPrice(priceCents) {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'narrowSymbol',
          maximumFractionDigits: 0,

        }).format(priceCents / 100).replace(/\s(?=€)/, '');
      }

      check() {
        this.classList.add('checked');
      }

      uncheck() {
        this.classList.remove('checked');
      }

      get discountTagElement() {
        return this.querySelector('.quick-quantity-selector_discount-tag');
      }

      get connectedSalePriceElement() {
        return this.closest('.product-info').querySelector('price-list sale-price');
      }

      get connectedCompareAtPriceExperimentElement() {
        return this.closest('.product-info').querySelector('price-list compare-at-price[data-experiment-id="1004184926"][data-experiment-treatment="1"]');
      }

      get connectedUnitPriceElement() {
        return this.closest('.product-info').querySelector('price-list unit-price');
      }

      get connectedQuantityInputElement() {
        return this.closest('.product-info').querySelector('quantity-selector input');
      }

      get connectedOnSaleBadgeElement() {
        return this.closest('.product-info').querySelector('on-sale-badge');
      }

      get connectedOnSaleBadgeExperimentElement() {
        return this.closest('.product-info').querySelector('on-sale-badge[data-experiment-id="1004184926"][data-experiment-treatment="1"]');
      }

      get labelElement() {
        return this.querySelector('span.quick-quantity-selector_label');
      }

      get connectedOptionLabelElement() {
        return this.closest('.QuickQuantitySelectors').querySelector('.variant-picker__option-info span');
      }
    }

    customElements.define('quick-quantity-selector', QuickQuantitySelector, { extends: 'button' });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trustpilot-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('trustpilot-gallery')) {
    class TrustpilotGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.loadMoreButton = this.querySelector('button');
        this.loadMoreButton.addEventListener('click', this.handleLoadMoreClick.bind(this));
      }

      handleLoadMoreClick() {
        const hiddenCards = this.querySelectorAll('.trustpilot-card[hidden]');
        const cardsToShow = Array.from(hiddenCards).slice(0, 6);

        cardsToShow.forEach((card) => {
          card.removeAttribute('hidden');
        });

        if (this.querySelectorAll('.trustpilot-card[hidden]').length === 0) {
          this.loadMoreButton.setAttribute('hidden', '');
        }
      }
    }

    customElements.define('trustpilot-gallery', TrustpilotGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
